import { compact, getSlotCompoundVariant, memo, splitProps } from '../helpers.mjs';
import { createRecipe } from './create-recipe.mjs';

const tableFooterDefaultVariants = {}
const tableFooterCompoundVariants = []

const tableFooterSlotNames = [
  [
    "root",
    "table-footer__root"
  ],
  [
    "content",
    "table-footer__content"
  ],
  [
    "paginationArea",
    "table-footer__paginationArea"
  ],
  [
    "trailingArea",
    "table-footer__trailingArea"
  ],
  [
    "totalCount",
    "table-footer__totalCount"
  ],
  [
    "pageSizeSelect",
    "table-footer__pageSizeSelect"
  ]
]
const tableFooterSlotFns = /* @__PURE__ */ tableFooterSlotNames.map(([slotName, slotKey]) => [slotName, createRecipe(slotKey, tableFooterDefaultVariants, getSlotCompoundVariant(tableFooterCompoundVariants, slotName))])

const tableFooterFn = memo((props = {}) => {
  return Object.fromEntries(tableFooterSlotFns.map(([slotName, slotFn]) => [slotName, slotFn.recipeFn(props)]))
})

const tableFooterVariantKeys = []
const getVariantProps = (variants) => ({ ...tableFooterDefaultVariants, ...compact(variants) })

export const tableFooter = /* @__PURE__ */ Object.assign(tableFooterFn, {
  __recipe__: false,
  __name__: 'tableFooter',
  raw: (props) => props,
  classNameMap: {},
  variantKeys: tableFooterVariantKeys,
  variantMap: {},
  splitVariantProps(props) {
    return splitProps(props, tableFooterVariantKeys)
  },
  getVariantProps
})